module.exports = __webpack_public_path__ + "static/media/Marco Ramolla.5b3e1545.png";